<div class="form-inner-box text-primary">
  <h4 class="text-capitalize position-relative pt-3">Reset Password</h4>
  <p>
    <small class="text-capitalize">
      Now you can reset your password with just entering new password here.
    </small>
  </p>
  <form [formGroup]="resetPassword" (ngSubmit)="resetUserPassword()">
    <div class="pwd-box">
      <input class="form-control mb-3" [type]="showHidePassword?'text':'password'" [formControl]="password"
        placeholder="Enter password">
      <span class="cursor-pointer"><i (click)="passwordShowHide()" class="fa-solid"
          [ngClass]="showHidePassword?'fa-eye-slash':'fa-eye'"></i></span>
    </div>
    @if ((password?.touched || password?.dirty || submitted ) && !password?.valid && !password?.pending) {
    <span class="text-danger error">
      @if (password?.errors.required) {
      Password is required
      }
      @if (password?.errors.minlength) {
      Minimum 6 characters required
      }
      @if (password?.errors.maxlength) {
      Maximum 20 characters allowed
      }
    </span>
    }
    <div class="pwd-box">
      <input class="form-control mb-3" [type]="showHideConfirmPassword?'text':'password'"
        [formControl]="password_confirmation" placeholder="Enter confirm password">
      <span class="cursor-pointer"><i (click)="confirmPasswordShowHide()" class="fa-solid"
          [ngClass]="showHideConfirmPassword?'fa-eye-slash':'fa-eye'"></i></span>
    </div>
    @if ((password_confirmation?.touched || password_confirmation?.dirty || submitted ) && !password_confirmation?.valid
    && !password_confirmation?.pending) {
    <span class="text-danger error">
      @if (password_confirmation?.errors.required) {
      Confirm password is required
      }
      @if (password_confirmation?.errors.mustMatch) {
      Confirm Password Does not match With Password
      }
    </span>
    }

    <div class="d-flex justify-content-between align-items-center flex-column flex-xl-row">
      <button class="btn btn-success cursor-pointer" type="submit"><span>Submit</span></button>
      <button class="btn btn-outline-success cursor-pointer" type="button" (click)="cancelReset()"><span
          class="close-icon">Cancel</span></button>
    </div>
  </form>
</div>